<template>
  <div>
    <div v-if="titled"><span>{{ $t('Components') }}:</span></div>
    <div
      v-for="component in components"
      :key="component.key"
      :class="titled ? 'mx-2' : ''"
      class="font-weight-light caption">
      <span>{{ component.quantity }}x </span>
      <router-link
        v-if="linked"
        :to="{
          name: 'single-product',
          params: { id: component.id }
        }"
        target="_blank"
      >
        <span>{{ component.name }}</span>
      </router-link>
      <span v-else>{{ component.name }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LineItemComponents',

  props: {
    components: {
      type: Array,
      required: true
    },
    linked: {
      type: Boolean,
      default: false
    },
    titled: {
      type: Boolean,
      default: false
    }
  }
}
</script>
